import {MultiSelect} from 'primereact/multiselect';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseInputComponent from './BaseInputComponent';
import TemplateUtils from '../../utils/TemplateUtils';

class InputMultiSelectComponent extends BaseInputComponent {
    renderView() {
        const {colClass, id, insideTable, label, showLabel, value, validateViewMode, validator, validators,
            optionLabel, chipColor, display} = this.props;
        return (
            <div className={insideTable ? '' : colClass}>
                <div className={insideTable ? '' : 'row'}>
                    <div className={insideTable ? '' : 'col-md-12 form-group'}>
                        {label !== undefined && showLabel ? (
                            <label id={`${id}-label-id`} className='p-label' htmlFor={id} style={{width: '100%'}}>
                                {label}
                            </label>
                        ) : null}
                        <span id={`${id}-view-value`} aria-label={label} aria-labelledby={`${id}-label-id`} className='p-inputtext-view'>
                            {/* {value && value.length > 0 ? value.map((v) => v[optionLabel]).join(', ') : ''} */}
                            {value && value.length > 0 && display === 'chip-colored' ? (
                                <div>
                                    {value.map(item => {
                                        return (
                                            TemplateUtils.multiselectColoredItemTemplate(item, optionLabel, chipColor, false)
                                        )
                                    })}
                                </div>
                            ) : ''}
                            {value && value.length > 0 && display !== 'chip-colored' ? (
                                value.map((v) => v[optionLabel]).join(', ')
                            ) : ''}
                        </span>
                        {validateViewMode && validator ? validator.message(id, label, value, validators) : null}
                    </div>
                </div>
            </div>
        );
    }

    renderEdit() {
        return this.renderNew();
    }

   
    renderNew() {
        const {
            colClass,
            dataKey,
            disableAllChecked,
            disabled,
            filter,
            filterBy,
            id,
            insideTable,
            label,
            name,
            selectedItemTemplate,
            maxSelectedLabels,
            onAfterStateChange,
            onChange,
            optionLabel,
            options,
            optionDisabledField,
            optionDisabledReversed,
            optionsDisabled,
            placeholder,
            selectedItemsLabel,
            showClear,
            showLabel,
            stateField,
            validator,
            validators,
            value,
            itemTemplate,
            display,
            chipColor
        } = this.props;
        const required = validators !== undefined && validators.includes('array_required') && !validators.includes('not_required');
        let finalSelectedItemTemplate = selectedItemTemplate;
        if (!finalSelectedItemTemplate && display === 'chip-colored') {
            finalSelectedItemTemplate = item => TemplateUtils.multiselectColoredItemTemplate(item, optionLabel, chipColor, true, value, (newValue => {
                if (onChange) {
                    const changeEvent = {
                        value: newValue,
                        target: {id, name, value: newValue}
                    }
                    onChange('MULTI_SELECT', undefined, changeEvent, onAfterStateChange, stateField);
                }
            }));
        }
        let finalItemTemplate = itemTemplate;
        if (!finalItemTemplate && display === 'chip-colored') {
            finalItemTemplate = item => TemplateUtils.multiselectColoredItemTemplate(item, optionLabel, chipColor, false);
        }
        
        return (            
            <div className={insideTable ? '' : colClass}>
                <div className={insideTable ? '' : 'row'}>
                    <div className={insideTable ? '' : 'col-md-12 form-group'}>
                        {label !== undefined && showLabel ? (
                            <label id={`${id}-label-id`} className='p-label' htmlFor={id} style={{width: '100%'}}>
                                {label}
                            </label>
                        ) : null}
                        <MultiSelect
                            aria-describedby={`${id}-error`}
                            aria-label={label}
                            aria-labelledby={label === undefined && showLabel ? `${id}-label-id` : undefined}
                            disableAllChecked={disableAllChecked}
                            key={id}
                            id={id}
                            name={name}
                            selectedItemTemplate={finalSelectedItemTemplate}
                            itemTemplate={finalItemTemplate}
                            style={{width: '100%'}}
                            value={value}
                            options={options}
                            optionLabel={optionLabel}
                            optionDisabledField={optionDisabledField}
                            optionDisabledReversed={optionDisabledReversed}
                            optionsDisabled={optionsDisabled}
                            dataKey={dataKey}
                            onChange={(e) => (onChange ? onChange('MULTI_SELECT', undefined, e, onAfterStateChange, stateField) : null)}
                            placeholder={placeholder}
                            filter={filter}
                            filterBy={filterBy}
                            showClear={showClear}
                            validator={validator}
                            validators={validators}
                            disabled={disabled}
                            display={finalSelectedItemTemplate ? 'comma' : 'chip'}
                            selectedItemsLabel={selectedItemsLabel}
                            maxSelectedLabels={maxSelectedLabels}
                            required={required}
                        />
                        <div aria-live='assertive'>{validator ? validator.message(id, label, value, validators) : null}</div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {rendered, viewMode} = this.props;
        if (rendered) {
            switch (viewMode) {
                case 'NEW':
                    return this.renderNew();
                case 'EDIT':
                    return this.renderEdit();
                case 'VIEW':
                default:
                    return this.renderView();
            }
        } else {
            return null;
        }
    }
}

InputMultiSelectComponent.defaultProps = {
    colClass: 'col-xl-4 col-lg-6 col-md-6 col-sm-12',
    disableAllChecked: false,
    disabled: false,
    filter: false,
    filterBy: 'label',
    insideTable: false,
    maxSelectedLabels: 4,
    optionsDisabled: false,
    optionDisabledReversed: false,
    placeholder: 'Wybierz',
    rendered: true,
    selectedItemsLabel: 'Wybrano {0} pozycji',
    showClear: false,
    showLabel: true,
    stateField: 'element',
    validateViewMode: false,
    selectedItemTemplate:undefined,
    validators: 'array_required',
    viewMode: 'VIEW',
    display: 'chip', //chip, chip-colored
    chipColor: 'color' //nazwa pola z wartością koloru
};

InputMultiSelectComponent.propTypes = {
    colClass: PropTypes.string,
    dataKey: PropTypes.string,
    disableAllChecked: PropTypes.bool,
    disabled: PropTypes.bool,
    filter: PropTypes.bool,
    filterBy: PropTypes.string,
    id: PropTypes.string.isRequired,
    insideTable: PropTypes.bool,
    label: PropTypes.string.isRequired,
    maxSelectedLabels: PropTypes.number,
    name: PropTypes.string.isRequired,
    onAfterStateChange: PropTypes.func,
    selectedItemTemplate: PropTypes.func,
    onChange: PropTypes.func,
    optionDisabledField: PropTypes.string,
    optionDisabledReversed: PropTypes.bool,
    optionLabel: PropTypes.string,
    options: PropTypes.array.isRequired,
    optionsDisabled: PropTypes.bool,
    placeholder: PropTypes.string,
    rendered: PropTypes.bool,
    selectedItemsLabel: PropTypes.string,
    showClear: PropTypes.bool,
    showLabel: PropTypes.bool,
    stateField: PropTypes.string,
    validateViewMode: PropTypes.bool,
    validator: PropTypes.object,
    validators: PropTypes.string,
    value: PropTypes.array,
    viewMode: PropTypes.string,
    display: PropTypes.string,
    chipColor: PropTypes.string,
};

export default withTranslation()(InputMultiSelectComponent);
